import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ArrowsOut = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.712 69.854.022 98.127a1.606 1.606 0 0 0 .449 1.401l.002.003c.37.368.893.535 1.406.447l28.197-4.765a1.608 1.608 0 0 0 1.264-1.1 1.605 1.605 0 0 0-.396-1.628l-5.513-5.513L40.233 72.17c.63-.629.63-1.647 0-2.277l-10.2-10.201a1.61 1.61 0 0 0-2.278 0L12.954 74.493l-5.515-5.515a1.61 1.61 0 1 0-2.727.876zm90.576-39.708 4.69-28.273a1.609 1.609 0 0 0-.449-1.4L99.527.47a1.614 1.614 0 0 0-1.406-.447L69.924 4.788a1.61 1.61 0 0 0-.869 2.728l5.513 5.513L59.766 27.83a1.61 1.61 0 0 0 0 2.278l10.2 10.201a1.61 1.61 0 0 0 2.278 0l14.802-14.802 5.515 5.515a1.613 1.613 0 0 0 2.727-.876zM69.854 95.288l28.271 4.69a1.605 1.605 0 0 0 1.401-.449l.002-.003a1.61 1.61 0 0 0 .448-1.406l-4.765-28.196a1.61 1.61 0 0 0-2.728-.869l-5.513 5.513-14.801-14.803a1.61 1.61 0 0 0-2.277.001L59.691 69.967a1.61 1.61 0 0 0 0 2.277l14.802 14.802-5.515 5.515a1.612 1.612 0 0 0 .876 2.727zM30.146 4.712 1.874.022A1.605 1.605 0 0 0 .473.471L.47.474c-.367.37-.534.892-.447 1.406l4.766 28.197a1.61 1.61 0 0 0 1.099 1.264 1.604 1.604 0 0 0 1.629-.395l5.513-5.513 14.8 14.801c.63.63 1.648.63 2.278.001l10.201-10.201a1.61 1.61 0 0 0 0-2.278L25.507 12.954l5.515-5.515a1.617 1.617 0 0 0 .394-1.63 1.608 1.608 0 0 0-1.27-1.097z"
  }));
});
ArrowsOut.displayName = 'ArrowsOut';
export var ArrowsOutDimensions = {
  height: 100,
  width: 100
};